import {
  IPolicyVehicle,
  TAZVehicleVariables,
  TCAVehicleVariables,
  TGenericVehicleVariables,
  TPolicyVehicleFormValues,
  TSCVehicleVariables,
  TVehicleVariables,
} from '../../../interfaces';

export function getRegionSpecificPolicyVehicleVariables(
  values: TPolicyVehicleFormValues,
  regionCode: string,
  currentVehicle?: IPolicyVehicle
): {
  passive_restraint_device?:
    | 'none'
    | 'passenger_seatbelt'
    | 'single_airbag'
    | 'double_airbag'
    | null;
  anti_theft_device?: boolean | null;
  rideshare_use: boolean;
  variables: TVehicleVariables;
} {
  const isOwned = values.ownership_status === 'owned';
  const sharedVariables = {
    collision_deductible: values.collision_deductible,
    comprehensive_deductible: values.collision_deductible,
    towing_road_services: values.towing_road_services,
    oem_parts: values.oem_parts,
    new_car_replacement: values.new_car_replacement,
  };
  switch (regionCode) {
    case 'CA':
      return {
        rideshare_use: false,
        anti_theft_device: values.anti_theft_device!,
        variables: {
          ...currentVehicle?.variables,
          additional_equipment: values.additional_equipment,
          collision_deductible: values.collision_deductible,
          collision_deductible_waiver: values.collision_deductible_waiver,
          comprehensive_deductible: values.collision_deductible,
          rental_reimbursement: values.rental_reimbursement,
          roadside_assistance: true,
          uninsured_motorist_property_damage_limit:
            values.uninsured_motorist_property_damage_limit!,
        } as TCAVehicleVariables,
      };
    case 'CO':
    case 'GA':
    case 'IL':
    case 'IN':
    case 'MO':
    case 'OH':
    case 'OR':
    case 'TN':
    case 'TX':
    case 'VA':
    case 'WI':
      return {
        rideshare_use: values.side_hustle!,
        anti_theft_device: values.anti_theft_device!,
        variables: {
          ...currentVehicle?.variables,
          ...sharedVariables,
          temporary_ride: values.temporary_ride!,
          gap: isOwned ? false : values.gap!,
          side_hustle: values.side_hustle!,
          uninsured_motorist_property_damage_limit:
            values.uninsured_motorist_property_damage_limit!,
        } as TGenericVehicleVariables,
      };
    case 'PA':
      return {
        rideshare_use: values.side_hustle!,
        passive_restraint_device: values.passive_restraint_device!,
        anti_theft_device: values.anti_theft_device!,
        variables: {
          ...currentVehicle?.variables,
          ...sharedVariables,
          temporary_ride: values.temporary_ride!,
          gap: isOwned ? false : values.gap!,
          side_hustle: values.side_hustle!,
          uninsured_motorist_property_damage_limit:
            values.uninsured_motorist_property_damage_limit!,
        } as TGenericVehicleVariables,
      };
    case 'AZ':
      return {
        rideshare_use: values.side_hustle!,
        variables: {
          ...currentVehicle?.variables,
          ...sharedVariables,
          temporary_ride: values.temporary_ride!,
          gap: isOwned ? false : values.gap!,
          side_hustle: values.side_hustle!,
          glass: values.glass!,
        } as TAZVehicleVariables,
      };

    case 'SC':
    default:
      return {
        rideshare_use: values.ridesharing!,
        variables: {
          ...currentVehicle?.variables,
          ...sharedVariables,
          loss_of_use: values.loss_of_use!,
          loan_lease_payoff: isOwned ? false : values.loan_lease_payoff!,
          ridesharing: values.ridesharing!,
        } as TSCVehicleVariables,
      };
  }
}
